import { render, staticRenderFns } from "./ThemeFilterCheckboxes.vue?vue&type=template&id=047d2e4c"
import script from "./ThemeFilterCheckboxes.vue?vue&type=script&lang=js"
export * from "./ThemeFilterCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports